module.exports = __webpack_public_path__ + "img/login_img.a5965246.svg";